__webpack_require__.p = "https://assets.canny.io/71bef7a5e338973587555148f64f04edc28bd99b/";